export class RequestAuthentication {
    portalName: string;
    token: string;
}
